import React, { Component } from 'react'

export default class PromoItem extends Component {
	render() {

		const { promo } = this.props

		let element = null

		if(promo.href){
			element = (
				<a className="pano_promo" href={promo.href} target="_blank" rel="noopener noreferrer">
					<img src={promo.img} alt={promo.alt} />
				</a>
			)
		}else{
			element = (
				<div className="pano_promo">
					<img src={promo.img} alt={promo.alt} />
				</div>
			)
		}

		return (
			element
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/home/PromoItem.js